import { getLanguage } from './i18n.js';

export class ApiError extends Error {
  constructor(message, status = 0, code = 'UNAVAILABLE') { super(message); this.status = status; this.code = code; }
}
export async function getJson(path, { signal } = {}) {
  let response;
  try {
    response = await fetch(`/api/v1${path}`, { headers: { Accept: 'application/json' }, cache: 'no-store',
      signal: signal ? AbortSignal.any([signal, AbortSignal.timeout(8000)]) : AbortSignal.timeout(8000) });
  } catch {
    if (signal?.aborted) throw new DOMException('Cancelled', 'AbortError');
    throw new ApiError('Не удалось загрузить данные. Проверьте соединение и повторите попытку.');
  }
  let payload;
  try { payload = await response.json(); } catch { throw new ApiError('Сервер вернул некорректный ответ.', response.status); }
  if (!response.ok) throw new ApiError(payload?.error?.code === 'MAINTENANCE' ? 'Техническое обслуживание. Пожалуйста, попробуйте позже.'
    : response.status === 401 ? 'Сессия завершена. Войдите снова.' : response.status === 403 ? 'Недостаточно прав для доступа.'
    : response.status === 404 ? 'Материал не найден или больше не опубликован.' : 'Данные временно недоступны. Повторите попытку.', response.status, payload?.error?.code);
  if (!payload || !Object.hasOwn(payload, 'data')) throw new ApiError('Сервер вернул некорректный ответ.');
  return payload;
}
export async function getSiteConfig(options) {
  const payload = await getJson(`/site-config?lang=${getLanguage()}`, options);
  const data = payload?.data;
  if (!data || typeof data.name !== 'string' || typeof data.missionText !== 'string' || typeof data.whoamiText !== 'string'
    || !Array.isArray(data.featureCards) || typeof data.maintenance?.enabled !== 'boolean') {
    throw new Error('Сервер вернул некорректные настройки сайта.');
  }
  return data;
}
export async function getHomeContent(options) { return (await getJson(`/home?lang=${getLanguage()}`, options)).data; }
export async function getAbout(options) { return (await getJson(`/about?lang=${getLanguage()}`, options)).data; }
export async function getCategories(options) { return (await getJson(`/categories?lang=${getLanguage()}`, options)).data; }
export async function getFileSections(options) { return (await getJson(`/file-sections?lang=${getLanguage()}`, options)).data; }
export function getPosts({ category, q, page = 1, limit = 6 }, options) {
  const query = new URLSearchParams({ page: String(page), limit: String(limit) });
  query.set('lang', getLanguage());
  if (category && category !== 'all') query.set('category', category);
  if (q) query.set('q', q);
  return getJson(`/posts?${query}`, options);
}
export async function getPost(slug, options) { return (await getJson(`/posts/${encodeURIComponent(slug)}?lang=${getLanguage()}`, options)).data; }
